// External Dependencies:
import { browserHistory } from 'react-router'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import Cookies from 'js-cookie'

// Internal Dependencies:
import { doRequest } from 'church-theme-library/utilities/request'

// Events:
const eventPageUpdated = document.createEvent( 'Event' )
eventPageUpdated.initEvent( 'dkePageUpdated', true, true )

export function requestPage( type, slug, requestOnly ) {
	return {
		type: 'REQUEST_PAGE_DATA',
		payload: {
			type: type,
			slug: slug,
			requestOnly: requestOnly
		}
	}
}

export function receivePage( type, subType, slug, json ) {
	return {
		type: 'RECEIVE_PAGE_DATA',
		payload: {
			type: type,
			subType: subType,
			slug: slug,
			data: json
		}
	}
}

export function receivePartialPage( slug, data, dkePageData = false ) {
	return {
		type: 'RECEIVE_PARTIAL_PAGE_DATA',
		payload: {
			slug,
			data,
			dkePageData
		}
	}
}

export function receivePageError( json ) {
	return {
		type: 'RECEIVE_PAGE_ERROR',
		payload: json
	}
}

export function setCurrentPage( type, slug ) {
	document.body.classList.add( 'is-ready' )

	return {
		type: 'SET_CURRENT_PAGE',
		payload: {
			type: type,
			slug: slug
		}
	}
}

export function appendPage( slug ) {
	return {
		type: 'APPEND_PAGE',
		payload: slug
	}
}

export function setCurrentlyViewedPage( slug, match ) {
	const url = match.path.replace( /(:slug)/g, slug )

	// Update url:
	window.history.pushState( null, null, url )

	return {
		type: 'SET_CURRENTLY_VIEWED_PAGE',
		payload: slug
	}
}

export function registerPageView( id ) {
	return function( dispatch, getState ) {
		const { pageViewsRegisteredIds } = getState().page

		if ( pageViewsRegisteredIds.includes( id ) ) {
			return
		}

		const url = `${siteData.api_base_url}post-view/?id=${id}`

		return doRequest( url, {
			credentials: 'include'
		} )
			.then( json => {
				dispatch( updatePageViewsRegistered( id ) )
			} )
			.catch( error => {
				console.log( error, 'error' )
			} )
	}
}

export function updatePageViewsRegistered( id ) {
	return {
		type: 'UPDATE_PAGE_VIEWS_REGISTERED',
		payload: id
	}
}

export function getPageData( {
	type = 'page',
	subType = '',
	isArchive = false,
	slug = '',
	categorySlug = '',
	year = '',
	month = '',
	archivePageNumber = false,
	skip = 0,
	number = 1,
	requestOnly = false,
	force = false,
	forceUpdatePostSets = false,
	append = false
} = {} ) {
	return function( dispatch, getState ) {
		const { byId, archiveCategoriesById, loadingById, receivedPageDataCache } = getState().page
		const { locale, userIsLoggedIn, wpRestNonce } = getState().site
		const theSubType = subType ? `-${subType}` : ''

		// Get slug:
		if ( ! slug && categorySlug ) {
			slug = categorySlug
		}

		// Normalise slug, removing /:
		slug = slug ? slug.replace( /\//g, '' ) : false
		categorySlug = categorySlug ? categorySlug.replace( /\//g, '' ) : false

		// Use localised version of home page:
		if ( 'home' == slug ) {
			slug = `${slug}__${locale}`
		}

		// When loading the page, the requested pages data will be added
		// to the html source as vlPageData. If it matches this request, use it.
		// Should only be present if not logged in.
		if (
			( ! append && ! requestOnly && ! force ) &&
			window.vlPageData && window.vlPageData.slug == slug
		) {
			dispatch( receivePage( type, subType, slug, window.vlPageData ) )
			dispatch( setCurrentPage( type, slug ) )
			dispatch( maybeUpdatePostSets( true ) )

			return
		}

		// Get id:
		const theById = isArchive ? archiveCategoriesById : byId
		const theId = type ?`id_${type}_${slug}` : `id_${slug}`
		const localeUnchanged = ! theById[ theId ] || ! theById[ theId ]['locale'] || theById[ theId ]['locale'] == locale

		// Don't load the same thing simultaneously:
		if ( loadingById[ theId ] ) {
			return
		}

		// Check cache:
		const thisRequestId = `${type}_subType_${subType}_isArchive_${isArchive}_slug_${slug}_categorySlug_${categorySlug}_year_${year}_month_${month}_archivePageNumber_${archivePageNumber}_skip_${skip}_number_${number}`

		if ( ! force && ! userIsLoggedIn && receivedPageDataCache[ thisRequestId ] ) {
			dispatch( handlePageDataResponse( {
				type,
				subType,
				isArchive,
				slug,
				categorySlug,
				year,
				month,
				archivePageNumber,
				skip,
				number,
				requestOnly,
				force,
				forceUpdatePostSets,
				append
			}, receivedPageDataCache[ thisRequestId ] ) )

			return
		}

		// force = false

		// Short circuit for existing data (unless logged in):
		// if ( ! force && ! userIsLoggedIn && theById[ theId ] ) {
		// 	if ( ! requestOnly && localeUnchanged ) {
		// 		dispatch( receivePage( type, subType, slug, theById[ theId ] ) )
		// 	}

		// 	if ( ! append && ! requestOnly && localeUnchanged ) {
		// 		dispatch( setCurrentPage( type, slug ) )
		// 		dispatch( maybeUpdatePostSets( true ) )
		// 	}

		// 	return
		// }

		// Not in cache: get from api.

		dispatch( requestPage( type, theId, requestOnly ) )

		if ( ! requestOnly ) {
			dispatch( showLoading() )
		}

		let url = `${siteData.api_base_url}${type}${theSubType}/?slug=${slug}`

		if ( locale ) {
			url += `&locale=${locale}`
		}

		if ( categorySlug ) {
			url += `&category_slug=${categorySlug}`
		}

		if ( year ) {
			url += `&year=${year}`
		}

		if ( month ) {
			url += `&month=${month}`
		}

		if ( archivePageNumber ) {
			url += `&page_number=${archivePageNumber}`
		}

		if ( skip ) {
			url += `&skip=${skip}`
		}

		if ( number ) {
			url += `&number=${number}`
		}

		let pagePassword = Cookies.get( `${type}_password_${slug}` )

		if ( pagePassword ) {
			url += `&page_password=${pagePassword}`
		}

		let headers = wpRestNonce ? {
			'X-WP-Nonce': wpRestNonce
		} : {}

		return doRequest( url, {
			credentials: 'include',
			headers: headers
		} )
			.then( json => {
				if ( json && ! json.is_password_protected ) {
					dispatch( receivePageResponseForCache( thisRequestId, json ) )
				}

				dispatch( handlePageDataResponse( {
					type,
					subType,
					isArchive,
					slug,
					categorySlug,
					year,
					month,
					archivePageNumber,
					skip,
					number,
					requestOnly,
					force,
					forceUpdatePostSets,
					append
				}, json ) )
			} )
			.catch( error => {
				console.log( error, 'error' );
			} )
	}
}

export function receivePageResponseForCache( requestId, json ) {
	return {
		type: 'RECEIVE_PAGE_DATA_RESPONSE_FOR_CACHE',
		payload: {
			requestId,
			json
		}
	}
}

export function handlePageDataResponse( {
	type = 'page',
	subType = '',
	isArchive = false,
	slug = '',
	categorySlug = '',
	year = '',
	month = '',
	archivePageNumber = false,
	skip = 0,
	number = 1,
	requestOnly = false,
	force = false,
	forceUpdatePostSets = false,
	append = false
} = {}, json ) {
	return function( dispatch, getState ) {
		dispatch( receivePage( type, subType, slug, json ) )

		if ( ! requestOnly ) {
			dispatch( hideLoading() )
		}

		if ( ! append && ! requestOnly ) {
			dispatch( setCurrentPage( type, slug ) )
		}

		if ( append ) {
			dispatch( appendPage( slug ) )
		}

		if ( forceUpdatePostSets || ( ! append && ! requestOnly ) ) {
			dispatch( maybeUpdatePostSets( true ) )
		} else if ( ! append ) {
			dispatch( maybeUpdatePostSets() )
		}

		setTimeout( () => {
			window.dispatchEvent( eventPageUpdated )
		}, 200 )
	}
}

export function getPartialPageData( data ) {
	return function( dispatch, getState ) {
		const { loadingById, selected } = getState().page
		const { locale, userIsLoggedIn, wpRestNonce } = getState().site

		// Normalise slug, removing /:
		const slug = selected.slug ? selected.slug.replace( /\//g, '' ) : false
		const type = selected.post_type ? selected.post_type : false
		const theId = type ?`id_${type}_${slug}` : `id_${slug}`

		if ( ! slug ) {
			return
		}

		// Don't load the same thing simultaneously:
		if ( loadingById[ theId ] ) {
			return
		}

		dispatch( showLoading() )

		const url = `${siteData.api_base_url}partial/?post_id=${data.post_id}&partial_id=${data.screens_id}&locale=${locale}`
		let headers = wpRestNonce ? {
			'X-WP-Nonce': wpRestNonce
		} : {}

		return doRequest( url, {
			credentials: 'include',
			headers: headers
		} )
			.then( json => {
				dispatch( receivePartialPage( slug, json ) )

				setTimeout( () => {
					window.dispatchEvent( eventPageUpdated )

					setTimeout( () => {
						dispatch( hideLoading() )
					}, 500 )
				}, 200 )
			} )
			.catch( error => {
				console.log( error, 'error' );
			} )
	}
}

/**
 * Archives
 */

export function maybeUpdatePostSets( forceUpdate = false ) {
	return {
		type: 'MAYBE_UPDATE_POST_SETS',
		payload: {
			forceUpdate: forceUpdate
		}
	}
}

export function setArchiveDate( year = false, month = false ) {
	return function( dispatch, getState ) {
		dispatch( setArchiveDateDo( year, month ) )
		dispatch( loadMorePosts() )
	}
}

export function setArchiveDateDo( year = false, month = false ) {
	return {
		type: 'SET_ARCHIVE_DATE',
		payload: {
			year: year,
			month: month
		}
	}
}

export function loadMorePosts( subType = false ) {
	return function( dispatch, getState ) {
		const { selectedArchive, postsSetA, postsSetZ, selectedDateYear, selectedDateMonth } = getState().page
		const slug = selectedArchive.slug
		const skipNumber = postsSetA.length + postsSetZ.length

		if ( ! subType ) {
			subType = selectedArchive.type
		}

		if ( 'posts-category' == subType ) {
			subType = 'posts'
		}

		dispatch(
			getPageData( {
				type: 'more',
				subType: subType,
				categorySlug: slug,
				year: selectedDateYear,
				month: selectedDateMonth,
				number: 20,
				skip: skipNumber,
				requestOnly: true,
				force: false,
				forceUpdatePostSets: true
			} )
		)
	}
}

/**
 * Featured image
 */

export function getFeaturedImage( postId = false, slug = false, taxonomy = false ) {
	return function( dispatch, getState ) {
		const { locale } = getState().site
		const { selected, selectedArchive } = getState().page
		let page,
			updateDkePageData = true

		if ( selectedArchive ) {
			page = selectedArchive
		} else {
			page = selected
		}

		if ( ! slug ) {
			slug = page.slug ? page.slug.replace( /\//g, '' ) : false
		}

		if ( ! slug ) {
			return
		}

		if ( ! page.id ) {
			return
		}

		if ( postId && postId != page.id ) {
			updateDkePageData = false
		}

		if ( ! postId ) {
			postId = page.id
		}

		let url = `${siteData.api_base_url}featured-image/?id=${postId}&locale=${locale}&v=${siteData.version}`

		if ( taxonomy ) {
			url += `&taxonomy=${page.taxonomy}`
		} else if ( page.taxonomy ) {
			url += `&taxonomy=${page.taxonomy}`
		}

		return doRequest( url )
			.then( json => {
				if ( updateDkePageData ) {
					dispatch( receivePartialPage(
						slug,
						{
							featured_image: json
						},
						{
							featured_image_id: json.id
						}
					) )
				} else {
					dispatch( receivePartialPage(
						slug,
						{
							featured_image: json
						}
					) )
				}

				setTimeout( () => {
					window.dispatchEvent( eventPageUpdated )
				}, 200 )
			} )
			.catch( error => {

			} )
	}
}

/**
 * Social
 */

export function getFacebookFeed() {
	return function( dispatch, getState ) {
		const { locale } = getState().site

		let url = `${siteData.api_base_url}facebook-feed/?locale=${locale}&v=${siteData.version}`

		return doRequest( url )
			.then( json => {
				dispatch( receiveFacebookFeed( json ) )
			} )
			.catch( error => {

			} )
	}
}

export function receiveFacebookFeed( data ) {
	return {
		type: 'RECEIVE_FACEBOOK_FEED',
		payload: data
	}
}

export function getInstagramFeed() {
	return function( dispatch, getState ) {
		const { locale } = getState().site

		let url = `${siteData.api_base_url}instagram-feed/?locale=${locale}&v=${siteData.version}`

		return doRequest( url )
			.then( json => {
				dispatch( receiveInstagramFeed( json ) )
			} )
			.catch( error => {

			} )
	}
}

export function receiveInstagramFeed( data ) {
	return {
		type: 'RECEIVE_INSTAGRAM_FEED',
		payload: data
	}
}

/**
 * Images
 */

export function receiveDkeSectionImageUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_IMAGE_UPDATED',
		payload: data
	}
}

/**
 * Image galleries
 */

export function receiveDkeSectionImageGalleryUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_IMAGE_GALLERY_UPDATED',
		payload: data
	}
}

/**
 * Links
 */

export function receiveDkeSectionLinkUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_LINK_UPDATED',
		payload: data
	}
}

/**
 * Forms
 */

export function receiveDkeSectionFormUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_FORM_UPDATED',
		payload: data
	}
}

/**
 * Maps
 */

export function receiveDkeSectionMapUpdated( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_MAP_UPDATED',
		payload: data
	}
}

/**
 * Sections
 */

export function receiveDkeSectionAdded( id, data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_ADDED',
		payload: {
			id,
			data
		}
	}
}

export function receiveDkeSectionRemoved( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_REMOVED',
		payload: data
	}
}

export function receiveDkeSectionsReordered( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_REORDERED',
		payload: data
	}
}

export function receiveDkeSectionSettings( data ) {
	return {
		type: 'RECEIVE_DKE_SECTION_SETTINGS',
		payload: data
	}
}
